/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'social/twitter': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _fill="#8300BF" fill-rule="nonzero"><path pid="0" d="M15.61 30c-7.729-.008-13.992-6.271-14-14 .008-7.729 6.271-13.992 14-14 7.729.008 13.992 6.271 14 14-.008 7.729-6.271 13.992-14 14zm0-26c-6.624.007-11.993 5.376-12 12 .007 6.624 5.376 11.993 12 12 6.624-.007 11.993-5.376 12-12-.007-6.624-5.376-11.993-12-12z"/><path pid="1" d="M22.536 10.533a6.763 6.763 0 01-1.975.96 2.79 2.79 0 00-3.948-.266 2.761 2.761 0 00-.96 2.134v.64a6.621 6.621 0 01-5.55-2.828s-2.507 5.6 3.1 8.111a7.464 7.464 0 01-4.375 1.227c5.6 3.094 12.432 0 12.432-7.15a2.02 2.02 0 00-.053-.534 4.6 4.6 0 001.329-2.294z"/></g>'
  }
})
